module.exports = __WEBPACK_EXTERNAL_MODULE_63__;


/*****************
 ** WEBPACK FOOTER
 ** external "react"
 ** module id = 63
 ** module chunks = 0
 **/